import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../useI18n.js';
import { MessageBody } from './MessageBody';
import { Confetti } from './Confetti';

// Avatar anonyme "A1", "A2"... (couleur derivee du numero).
function AnonAv({ label }) {
  const n = parseInt((label || '').replace(/\D/g, ''), 10) || 0;
  const hue = (n * 67) % 360;
  return <span className="who-anon-av" style={{ background: `hsl(${hue} 55% 45%)` }}>A{n || '?'}</span>;
}

function Thread({ context, keyMsg, filledAnswer }) {
  return (
    <div className="who-thread">
      {context.map((m, i) => (
        <div key={i} className="who-msg">
          <AnonAv label={m.anon} />
          <div className="who-body"><div className="who-anon">{m.anon}</div><div className="who-text"><MessageBody content={m.text} imgClassName="who-img" /></div></div>
        </div>
      ))}
      <div className="who-msg key">
        <AnonAv label={keyMsg?.anon} />
        <div className="who-body">
          <div className="who-anon">{keyMsg?.anon}</div>
          <div className="who-text">{filledAnswer != null
            ? String(keyMsg?.text || '').replace(/█+/g, filledAnswer)
            : <MessageBody content={keyMsg?.text} imgClassName="who-img" />}</div>
        </div>
      </div>
    </div>
  );
}

// ---- Phase 1 : saisie du prenom ----
function GuessPhase({ context, keyMsg, timeLeft, onSubmit, submitted, progress }) {
  const { t } = useI18n();
  const [text, setText] = useState('');
  const armedRef = useRef(false);
  useEffect(() => {
    if (timeLeft > 1) armedRef.current = true;
    if (armedRef.current && !submitted && timeLeft <= 1 && text.trim()) onSubmit(text.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  return (
    <div className="who-round">
      <div className="create-head">
        <div className="create-prompt"><span className="cp-label">{t('whoHint') || 'Quel est le prénom caché ?'}</span></div>
        {timeLeft > 0 && <span className="chrono-timer">{timeLeft}s</span>}
      </div>
      <Thread context={context} keyMsg={keyMsg} />
      {submitted ? (
        <div className="mashup-status">{t('whoWaiting') || 'En attente des autres...'} {progress.length ? `(${progress.length})` : ''}</div>
      ) : (
        <div className="who-input-row">
          <input className="who-input" maxLength={40} placeholder={t('whoPlaceholder') || 'Tape le prénom...'}
            value={text} onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && text.trim()) onSubmit(text.trim()); }} />
          <button type="button" className="btn primary" disabled={!text.trim()} onClick={() => text.trim() && onSubmit(text.trim())}>{t('whoSubmit') || 'Deviner'}</button>
        </div>
      )}
    </div>
  );
}

// ---- Phase 2 : reveal anime du prenom ----
function RevealPhase({ reveal, myPseudo }) {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(false); const to = setTimeout(() => setShow(true), 450); return () => clearTimeout(to); }, [reveal]);
  const me = reveal?.results?.[myPseudo];
  const answer = reveal?.answer || '';

  return (
    <div className="who-round">
      <div className="create-head"><div className="create-prompt"><span className="cp-label">{t('whoAnswer') || 'C’était'}</span></div></div>
      <div className={`who-reveal-name${show ? ' show' : ''}`}>{answer}</div>
      <Thread context={[]} keyMsg={reveal?.key} filledAnswer={show ? answer : null} />
      <div className="who-results">
        {Object.entries(reveal?.results || {}).map(([p, r]) => (
          <div key={p} className={`who-res ${r.correct ? 'ok' : 'ko'}`}>
            <span className="who-res-badge">{r.correct ? '✓' : '✗'}</span>
            <span className="who-res-name">{p}</span>
            <span className="who-res-guess">« {r.guess} »</span>
          </div>
        ))}
      </div>
      <Confetti active={show && me?.correct} count={200} />
    </div>
  );
}

export function WhoRound({ phase, context = [], keyMsg, reveal, timeLeft, onSubmit, progress = [], myPseudo }) {
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => { setSubmitted(false); }, [keyMsg]);
  if (phase === 'reveal') return <RevealPhase reveal={reveal} myPseudo={myPseudo} />;
  if (phase !== 'guessing') return <div className="who-round"><div className="mashup-status">…</div></div>;
  const submit = (name) => { setSubmitted(true); onSubmit(name); };
  return <GuessPhase context={context} keyMsg={keyMsg} timeLeft={timeLeft} onSubmit={submit} submitted={submitted} progress={progress} />;
}
